import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

type EnvConfig = {
  sessionSampleRate: number;
  sessionReplaySampleRate: number;
  traceSampleRate: number;
};

const ENV_CONFIG: Record<string, EnvConfig> = {
  prod: {
    // RUM temporarily disabled — revert this commit to re-enable
    sessionSampleRate: 0,
    sessionReplaySampleRate: 0,
    traceSampleRate: 0,
  },
  staging: {
    sessionSampleRate: 5,
    sessionReplaySampleRate: 100,
    traceSampleRate: 100,
  },
  dev: {
    sessionSampleRate: 5,
    sessionReplaySampleRate: 10,
    traceSampleRate: 10,
  },
};

export const initDatadog = (): void => {
  const applicationId = process.env.REACT_APP_RUM_APPLICATION_ID;
  const clientToken = process.env.REACT_APP_RUM_CLIENT_TOKEN;

  if (!applicationId || !clientToken) return;

  const env = process.env.REACT_APP_ENVIRONMENT ?? '';
  const { sessionSampleRate, sessionReplaySampleRate, traceSampleRate } =
    ENV_CONFIG[env] ?? {
      sessionSampleRate: 0,
      sessionReplaySampleRate: 0,
      traceSampleRate: 0,
    };

  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'deckard-xcp-portal',
    env,
    version: process.env.REACT_APP_VERSION,
    sessionSampleRate,
    sessionReplaySampleRate,
    traceSampleRate,
    defaultPrivacyLevel: 'mask-user-input',
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    plugins: [reactPlugin({ router: false })],
    allowedTracingUrls: [/https:\/\/.*\.deckard\.com/],
  });

  if (sessionReplaySampleRate > 0) {
    datadogRum.startSessionReplayRecording();
  }
};
